<template>
   <div class="confirm-unloading">
       <AlertDialog v-model="visible"
                    :id="id"
                    title="Alert"
                    @ok="$emit('ok')">
           Could not update the state, please try again!
       </AlertDialog>
   </div>
</template>

<script>

import AlertDialog from '@/components/Core/Dialog/Alert'

export default {
  components: {
    AlertDialog
  },
  name: 'AlertError',
  props: {
    carItineraryHelper: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'show',
    event: 'visibility'
  },
  data () {
    return {
      visible: false,
      id: 'alert-error-' + this.carItineraryHelper.getCarItinerary().id
    }
  },
  watch: {
    show: function (newVal) {
      if (newVal) {
        this.visible = newVal
        this.$emit('visibility')
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
